const EVENT_CHANGE_SLIDE = 'template-preview:change-slide'

const EVENT_HISTORY_TYPE_UNDO = 'Undo'
const EVENT_HISTORY_TYPE_REDO = 'Redo'

const MAP_TYPE_EVENT_HISTORY = {
  undo: EVENT_HISTORY_TYPE_UNDO,
  redo: EVENT_HISTORY_TYPE_REDO,
}

const TRIGGER = {
  BLANK_FROM_ONBOARDING_V3: 'Blank from Onboarding v3',
}
export default {
  EVENT_CHANGE_SLIDE,
  EVENT_HISTORY_TYPE_UNDO,
  EVENT_HISTORY_TYPE_REDO,
  MAP_TYPE_EVENT_HISTORY,
  TRIGGER,
}
